import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalIconButton from '@/components/shared/ModalIconButton';
import { QRCanvas } from 'qrcanvas-vue';
import FormImageUploader from '@/components/shared/FormImageUploader';
import { Bus as VuedalsBus } from 'vuedals';
import WebSourceEmbedQRCodeModal from '@/components/web-source-management/WebSourceEmbedQRCodeModal';
var MIN_RENDERED_SIZE = 250;
var MAX_RENDERED_SIZE = 475;
var MIN_CANVAS_SIZE = 250;
var MAX_CANVAS_SIZE = 1200;
var SLOPE = (MAX_RENDERED_SIZE - MIN_RENDERED_SIZE) / (MAX_CANVAS_SIZE - MIN_CANVAS_SIZE);
export default {
  name: 'WebSourceQRCodeModal',
  components: {
    FormImageUploader: FormImageUploader,
    ModalIconButton: ModalIconButton,
    QRCanvas: QRCanvas
  },
  props: {
    webSourceLink: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: true,
      qrCodeBackgroundOptions: [{
        value: 'white',
        text: this.$t('qrCodeBackgroundOptions.white')
      }, {
        value: null,
        text: this.$t('qrCodeBackgroundOptions.transparent')
      }],
      qrCodeEffectOptions: [{
        value: null,
        text: this.$t('qrCodeEffectOptions.none')
      }, {
        value: 'fusion',
        text: this.$t('qrCodeEffectOptions.fusion')
      }, {
        value: 'round',
        text: this.$t('qrCodeEffectOptions.round')
      }],
      showSettings: false,
      settings: {
        qrCodeBackground: 'white',
        qrCodeForeground: '#000000',
        qrCodeEffect: null,
        qrCodeLogo: undefined,
        qrCodePadding: 15,
        qrCodeSize: 400,
        qrCodeRadiusValue: 50
      },
      qrCodeOptions: null
    };
  },
  computed: {
    canvasScalerStyle: function canvasScalerStyle() {
      var _this$qrCodeOptions;
      var currentSize = ((_this$qrCodeOptions = this.qrCodeOptions) === null || _this$qrCodeOptions === void 0 ? void 0 : _this$qrCodeOptions.size) | 0;
      var targetSize = MIN_RENDERED_SIZE + SLOPE * (currentSize - MIN_RENDERED_SIZE);
      var scale = targetSize / currentSize;
      return {
        transform: "scale(".concat(scale, ")")
      };
    }
  },
  watch: {
    settings: {
      deep: true,
      handler: function handler() {
        this.update();
      }
    }
  },
  mounted: function mounted() {
    this.update();
  },
  methods: {
    update: function update() {
      var options = {
        background: this.settings.qrCodeBackground,
        foreground: this.settings.qrCodeForeground,
        size: this.settings.qrCodeSize,
        padding: this.settings.qrCodePadding,
        effect: {
          type: this.settings.qrCodeEffect,
          value: this.settings.qrCodeRadiusValue / 100
        },
        data: this.webSourceLink
      };
      if (this.settings.qrCodeLogo) {
        options.logo = this.settings.qrCodeLogo;
      }
      this.qrCodeOptions = Object.assign({}, options);
    },
    downloadQRCode: function downloadQRCode(imageFormat) {
      if (!['jpeg', 'png'].includes(imageFormat)) {
        throw new Error("Invalid Image Format '".concat(imageFormat, "' provided for QR Code."));
      }
      var format = "image/".concat(imageFormat);
      var link = document.createElement('a');
      link.download = "qrcode.".concat(imageFormat);
      link.href = document.getElementById('qrCodeCanvas').toDataURL(format);
      link.click();
    },
    showEmbedQRCodeModal: function showEmbedQRCodeModal() {
      VuedalsBus.$emit('new', {
        title: this.$t('embedQRCodeModalTitle'),
        name: 'embed-qr-code-modal',
        size: 'lg',
        closeOnBackdrop: false,
        props: {
          webSourceLink: this.webSourceLink
        },
        component: WebSourceEmbedQRCodeModal
      });
    },
    onImageChanged: function onImageChanged(encodedFile) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var image;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!encodedFile) {
                _context.next = 9;
                break;
              }
              image = new Image();
              image.src = "data:".concat(encodedFile.binaryFileContentType, ";base64, ").concat(encodedFile.binaryFile);
              _context.next = 5;
              return image;
            case 5:
              _this.settings.qrCodeLogo = _context.sent;
              _this.update();
              _context.next = 11;
              break;
            case 9:
              _this.settings.qrCodeLogo = undefined;
              _this.update();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeModal: function closeModal() {
      this.$vuedals.close();
    }
  }
};